(function () {
    'use strict';

    /**
     * An API request group gathers the results from multiple requests.
     * When all required requests are completed the final step of preparing the data is executed.
     * An example is when we have a installation request which uses a list of justifications.
     * We cannot (safely) process the list of justications until the installation request is loaded.
     * This can be handled in the controller but it is easier to wrap the logic into a group for which we can 
     * ensure that the required data is present.
     */

    angular.module('app').factory('apiRequestGroup', apiRequestGroup);

    apiRequestGroup.$inject = ['rx'];
    function apiRequestGroup(rx) {
        const service = {
            Create: create,
        };

        function create(expectedCount) {
            return new FiniteSubject(expectedCount);
        }

        return service;

        function FiniteSubject(expectedCount) {

            let count = 0;

            const innerSubject = new rx.Subject();
            
            this.next = function () {
                count++;

                if (count === expectedCount) {
                    innerSubject.onNext();
                }
            };

            this.subscribe = (observer) => innerSubject.subscribe(observer);
        }
    }
})();
